const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const getQuarterToDateRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed

  const quarterStartMonth = month - (month % 3);
  const startDate = new Date(year, quarterStartMonth, 1);
  const endDate = today;

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getYearToDateRange = () => {
  const now = new Date();
  const from = new Date(now.getFullYear(), 0, 1);
  const to = now;

  return {
    startDate: formatDate(from),
    endDate: formatDate(to)
  };
};

export const getLast1MonthRange = () => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setMonth(now.getMonth() - 1);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now)
  };
};

export const getLast3MonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setMonth(now.getMonth() - 3);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now)
  };
};

export const getLast6MonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setMonth(now.getMonth() - 6);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now)
  };
};

export const getLast12MonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setFullYear(now.getFullYear() - 1);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now)
  };
};

export const getLastFullMonthRange = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), 0);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getLast3FullMonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), 0);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getLast6FullMonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), 0);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getLast12FullMonthsRange = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 12, 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), 0);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getLastNDaysRange = (n) => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setDate(now.getDate() - n);

  const endDate = new Date(now);
  endDate.setDate(now.getDate() + n);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getCurrentMonthRange = () => {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now)
  };
};

export const getRiskManagementRange = () => {
  const now = new Date();
  const startDate = new Date(now);
  const endDate = new Date(now);
  startDate.setDate(now.getDate() - 60);
  endDate.setDate(now.getDate() + 60);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

export const getPortCongestionRange = (isImport = true) => {
  const now = new Date();
  const startDate = new Date(now);
  const endDate = new Date(now);
  const offset = isImport ? 10 : 14;
  startDate.setDate(now.getDate() - offset);
  endDate.setDate(now.getDate() + offset);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};
